<template>
  <div class="main pl-4" v-if="this.availablePhases.length > 0">
    <div class="title mb-3">CLASSIFICA</div>
    <b-container class="my-4">
      <b-row class="header text-center">
        <b-col cols="4"><!--***-->Fase</b-col>
        <b-col cols="4"><!--***-->Serie</b-col>
        <b-col cols="4"><!--***-->Girone</b-col>
      </b-row>
      <b-row class="text-center">
        <b-col cols="4">
          <combo-or-label v-model="selectedPhase" :options="availablePhases"></combo-or-label>
        </b-col>
        <b-col cols="4">
          <combo-or-label v-model="selectedSerie" :options="availableSeries"></combo-or-label>
        </b-col>
        <b-col cols="4">
          <combo-or-label v-model="selectedSector" :options="availableSectors"></combo-or-label>
        </b-col>
      </b-row>
      <b-row class="header text-center">
        <b-col cols="4"><!--***-->Sessione</b-col>
        <b-col cols="4"><!--***-->Round</b-col>
        <b-col cols="4"></b-col>
      </b-row>
      <b-row class="text-center">
        <b-col cols="4">
          <combo-or-label v-model="selectedSession" :options="availableSessions"></combo-or-label>
        </b-col>
        <b-col cols="4">
          <combo-or-label v-model="selectedRound" :options="availableRounds"></combo-or-label>
        </b-col>
        <b-col cols="4">

        </b-col>
      </b-row>
    </b-container>
      <b-checkbox size="lg" v-model="showCompotitions" class="float-right mb-2 ml-2"></b-checkbox>
      <div class="float-right p-1">Mostra formazioni</div>
    <template v-for="[type, rank] in Object.entries(ranksToBeShown)">
      <b-table :fields="fieldsToBeShownInRank" :items="rank.Rank" small striped :key="type" class="figbHeader">
        <template #cell(TeamName)="{item, value}">
          <div>{{value}}</div>
          <ul v-if="showCompotitions">
            <li v-for="player in getPlayersOfTeam(item.TeamId)">{{player}}</li>
          </ul>
        </template>
      </b-table>
    </template>
  </div>
</template>

<script>

import ComboOrLabel from "../components/lib/ComboOrLabel";
import {mapGetters} from "vuex";

export default {
  name: 'TeamRanks',
  components: {ComboOrLabel},
  data() {
    return {
      selectedPhase: 1,
      selectedSerie: -1,
      selectedSector: -1,
      selectedSession: -1,
      selectedRound: -1,
      currentDetailsTable: -1,
      showCompotitions: false
    }
  },
  computed: {
    ...mapGetters({
      teamId: 'tournament/teamId',
      teamRanks: 'ranks/teamRanks',
      sectors: 'tournament/sector',
      currentRound: 'tournament/currentRound',
      teamPlayers: 'players/teamPlayers',
      played: 'deals/played',
    }),
    ranksToBeShown() {
      if (this.selectedRound === -1) {
        return [];
      }

      return this.teamRanks
              ?.Phases[this.selectedPhase]
              ?.Series[this.selectedSerie]
              ?.Groups[this.selectedSector]
              ?.Sessions[this.selectedSession]
              ?.Rounds[this.selectedRound]
              ?.Rank ?? {};
    },
    availablePhases() {
      return Object.keys(this.teamRanks?.Phases ?? {}).sort((a, b) => a - b);
    },
    availableSeries() {
      return Object.keys(
          this.teamRanks.Phases[this.selectedPhase]?.Series ?? {}
      ).map(seriesId => {
        return {
          value: seriesId,
          text: this.sectors.Phases[this.selectedPhase].Series[seriesId].Sigla
        }
      }).sort((a, b) => a.text.localeCompare(b.text));
    },
    availableSectors() {
      return Object.entries(
          this.teamRanks
              ?.Phases[this.selectedPhase]
              ?.Series[this.selectedSerie]
              ?.Groups ?? {}
      ).map(([groupId, group]) => {
        const session = Object.keys(group.Sessions)[0];
        return {
          value: groupId,
          text: this.sectors.Phases[this.selectedPhase].Series[this.selectedSerie].Sessions[session].Groups[groupId].Sigla
        }
      }).sort((a, b) => a.text.localeCompare(b.text));
    },
    availableSessions() {
      if (this.selectedSector === -1) {
        return [];
      }
      return Object.keys(
          this.teamRanks
              ?.Phases[this.selectedPhase]
              ?.Series[this.selectedSerie]
              ?.Groups[this.selectedSector]
              ?.Sessions ?? {}
      ).sort((a, b) => a - b);
    },
    availableRounds() {
      if (this.selectedSession === -1) {
        return [];
      }
      return Object.keys(
          this.teamRanks
              ?.Phases[this.selectedPhase]
              ?.Series[this.selectedSerie]
              ?.Groups[this.selectedSector]
              ?.Sessions[this.selectedSession]
              ?.Rounds ?? {}
      ).sort((a, b) => a - b);
    },
    isTriplicateActive() {
      if (this.selectedRound < 1) {
        return [];
      }

      return this.sectors
          ?.Phases[this.selectedPhase]
          ?.Series[this.selectedSerie]
          ?.Sessions[this.selectedSession]
          ?.Groups[this.selectedSector]
          ?.Rounds[this.selectedRound]
          ?.UseTriplicate;
    },
    fieldsToBeShownInRank() {
      return [
        {
          key: 'Position',
          label: '#'
        },
        {
          key: 'TeamName',
          label: 'Squadra'
        },
        {
          key: 'TotalVps',
          label: 'VP'
        }
      ];
    }
  },
  methods: {
    openDetails(number) {
      this.currentDetailsTable = number;
    },
    closeDetails() {
      this.openDetails(-1);
    },
    getPlayersOfTeam(teamId)
    {
      return Object.values(this.teamPlayers).filter(plr => plr.Team === teamId).map(plr => plr.Name)
    }
  },
  watch: {
    selectedSession() {
      this.closeDetails();
    },
    selectedRound() {
      this.closeDetails();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.selectedPhase = Math.max(...this.availablePhases);
      this.$nextTick(() => {

        this.selectedRound = Math.max(...this.availableRounds);
        this.$nextTick(() => {
          const playedSeries = Object.keys(this.played
              ?.Phases[this.selectedPhase].Series ?? {});

          if (playedSeries.length === 1) {
            this.selectedSerie = parseInt(playedSeries[0]);
          }

          this.$nextTick(() => {
            let playedGroups;

            if (this.contestType === 0) {

              //Torneo a squadre
              playedGroups = Object.keys(this.played
                  ?.Phases[this.selectedPhase]?.Series[this.selectedSerie]?.Groups ?? {});
            } else {
              //Torneo a coppie, di solito Danese, non abbiamo le serie e gironi (lavoriamo per rankset)
              playedGroups = [1];
            }

            if (playedGroups.length === 1) {
              this.selectedSector = parseInt(playedGroups[0]);
            }

            this.$nextTick(() => {
              this.selectedSession = Math.max(...this.availableSessions);
              this.$nextTick(() => {
                this.selectedRound = Math.max(...this.availableRounds);
              });
            });
          });
        });
      });
    })
  }
};
</script>

<style scoped>
.nsText {
  color: #2661CE;
  font-weight: bold;
}

.ewText {
  color: #DC143C;
  font-weight: bold;
}

.impsResult {
  font-size: 2rem;
}

/deep/ .table > tbody > tr > td {
  vertical-align: middle;
}

>>> .figbHeader thead {
  color: #3396B8;
  background-color: white;
}



.title {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  color: #3396B8;
}
</style>
